import ActivityLogPanel from './activityLogPanel.container'

export default ActivityLogPanel